import { AuthenticationModalContext } from '@/contexts/AuthenticationModalContext';
import { useContext } from 'react';

export const useAuthenticationModal = () => {
  const context = useContext(AuthenticationModalContext);
  if (!context) {
    throw new Error(
      'useAuthenticationModal deve ser utilizado SnackbarProvider',
    );
  }
  return context;
};
